/**
 * Builds the Uppy multipart callbacks around the server-owned source identity.
 *
 * @param {Object} options uploader dependencies.
 * @returns {Object} callbacks accepted by Uppy's AwsS3 plugin.
 */
export const buildSharedVideoSourceMultipartOptions = ({
  collectionUrl,
  request,
  onSourceUpdate = () => {}
}) => {
  const sourceIdsByUpload = new Map();

  const memberUrl = (uploadId) => {
    const sourceId = sourceIdsByUpload.get(uploadId);
    if (!sourceId) throw new Error('video_source_identity_missing');

    return `${collectionUrl}/${encodeURIComponent(sourceId)}`;
  };

  return {
    shouldUseMultipart: true,
    limit: 5,

    async createMultipartUpload(file) {
      const source = await request(collectionUrl, {
        body: {
          original_filename: file.name,
          byte_size: file.size,
          content_type_hint: file.type
        }
      });
      sourceIdsByUpload.set(source.upload_id, source.id);
      onSourceUpdate(source);

      return { uploadId: source.upload_id, key: source.key };
    },

    async signPart(_file, { uploadId, key, partNumber }) {
      return request(`${memberUrl(uploadId)}/sign_part`, {
        body: { upload_id: uploadId, key, part_number: partNumber }
      });
    },

    async completeMultipartUpload(_file, { uploadId, key, parts }) {
      const source = await request(`${memberUrl(uploadId)}/complete`, {
        body: { upload_id: uploadId, key, parts }
      });
      onSourceUpdate(source);

      return { location: source.key };
    },

    async abortMultipartUpload(_file, { uploadId, key }) {
      await request(memberUrl(uploadId), {
        method: 'DELETE',
        body: { upload_id: uploadId, key }
      });
    }
  };
};
